import React from 'react';
import Utils from '../../lib/Utils';

class PhotoAssistForm extends React.Component {
  offer_types = [
    "アルバム同時販売"
  ]

  print_size = [
    "L判プリント(127㎜×89㎜)",
    "KG判プリント(152㎜×102㎜)",
    "2L判プリント(178㎜×127㎜)",
    "2LW判プリント(216㎜×127㎜)",
    "八つ切り判プリント(216㎜×152㎜)",
    "A4判プリント(297㎜×210㎜)",
    "ダウンロード"
  ]

  state = {
    categories: [1],

    school: this.props.data.school || this.props.data.albums[0].code,
    offer_type: this.offer_types[0],
    start_date:'',
    end_date:'',
    event_name: '',

    category_1_name:'',
    category_1_length:0,
    category_1_size_1:this.print_size[0],
    category_1_price_1:0,
    category_1_size_2:this.print_size[0],
    category_1_price_2:0,
    category_1_size_3:this.print_size[0],
    category_1_price_3:0,

    category_2_name:'',
    category_2_length:0,
    category_2_size_1:this.print_size[0],
    category_2_price_1:0,
    category_2_size_2:this.print_size[0],
    category_2_price_2:0,
    category_2_size_3:this.print_size[0],
    category_2_price_3:0,

    category_3_name:'',
    category_3_length:0,
    category_3_size_1:this.print_size[0],
    category_3_price_1:0,
    category_3_size_2:this.print_size[0],
    category_3_price_2:0,
    category_3_size_3:this.print_size[0],
    category_3_price_3:0,

    category_4_name:'',
    category_4_length:0,
    category_4_size_1:this.print_size[0],
    category_4_price_1:0,
    category_4_size_2:this.print_size[0],
    category_4_price_2:0,
    category_4_size_3:this.print_size[0],
    category_4_price_3:0,

    category_5_name:'',
    category_5_length:0,
    category_5_size_1:this.print_size[0],
    category_5_price_1:0,
    category_5_size_2:this.print_size[0],
    category_5_price_2:0,
    category_5_size_3:this.print_size[0],
    category_5_price_3:0,

    category_6_name:'',
    category_6_length:0,
    category_6_size_1:this.print_size[0],
    category_6_price_1:0,
    category_6_size_2:this.print_size[0],
    category_6_price_2:0,
    category_6_size_3:this.print_size[0],
    category_6_price_3:0,

    category_7_name:'',
    category_7_length:0,
    category_7_size_1:this.print_size[0],
    category_7_price_1:0,
    category_7_size_2:this.print_size[0],
    category_7_price_2:0,
    category_7_size_3:this.print_size[0],
    category_7_price_3:0,

    category_8_name:'',
    category_8_length:0,
    category_8_size_1:this.print_size[0],
    category_8_price_1:0,
    category_8_size_2:this.print_size[0],
    category_8_price_2:0,
    category_8_size_3:this.print_size[0],
    category_8_price_3:0,

    category_9_name:'',
    category_9_length:0,
    category_9_size_1:this.print_size[0],
    category_9_price_1:0,
    category_9_size_2:this.print_size[0],
    category_9_price_2:0,
    category_9_size_3:this.print_size[0],
    category_9_price_3:0,

    category_10_name:'',
    category_10_length:0,
    category_10_size_1:this.print_size[0],
    category_10_price_1:0,
    category_10_size_2:this.print_size[0],
    category_10_price_2:0,
    category_10_size_3:this.print_size[0],
    category_10_price_3:0,

    category_11_name:'',
    category_11_length:0,
    category_11_size_1:this.print_size[0],
    category_11_price_1:0,
    category_11_size_2:this.print_size[0],
    category_11_price_2:0,
    category_11_size_3:this.print_size[0],
    category_11_price_3:0,

    category_12_name:'',
    category_12_length:0,
    category_12_size_1:this.print_size[0],
    category_12_price_1:0,
    category_12_size_2:this.print_size[0],
    category_12_price_2:0,
    category_12_size_3:this.print_size[0],
    category_12_price_3:0,


    date_validate_message:null,
    event_name_validate_message:null,
    category_1_validate_message:null,
    category_2_validate_message:null,
    category_3_validate_message:null,
    category_4_validate_message:null,
    category_5_validate_message:null,
    category_6_validate_message:null,
    category_7_validate_message:null,
    category_8_validate_message:null,
    category_9_validate_message:null,
    category_10_validate_message:null,
    category_11_validate_message:null,
    category_12_validate_message:null,
  }

  getData = () => {
    let formData = {
      doc_date: (new Date()).toLocaleDateString('sv-SE'),
      customer: this.props.data.customerName,
      school: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      offer_type: this.state.offer_type,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      event_name: this.state.event_name,
    };
    for (let i = 1; i <= 12; i++) {
      if (this.state.categories.length >= i) {
        formData['category_'+i+'_name']   = this.state['category_'+i+'_name'];
        formData['category_'+i+'_length'] = this.state['category_'+i+'_length'];

        formData['category_'+i+'_size_1']  = this.state['category_'+i+'_size_1'];
        formData['category_'+i+'_price_1'] = this.state['category_'+i+'_price_1'];

        formData['category_'+i+'_size_2']  = this.state.categories[i-1] >= 2 ? this.state['category_'+i+'_size_2'] : '';
        formData['category_'+i+'_price_2'] = this.state.categories[i-1] >= 2 ? this.state['category_'+i+'_price_2'] : '';

        formData['category_'+i+'_size_3']  = this.state.categories[i-1] >= 3 ? this.state['category_'+i+'_size_3'] : '';
        formData['category_'+i+'_price_3'] = this.state.categories[i-1] >= 3 ? this.state['category_'+i+'_price_3'] : '';
      }
      else {
        formData['category_'+i+'_name']    = '';
        formData['category_'+i+'_length']  = '';
        formData['category_'+i+'_size_1']  = '';
        formData['category_'+i+'_price_1'] = '';
        formData['category_'+i+'_size_2']  = '';
        formData['category_'+i+'_price_2'] = '';
        formData['category_'+i+'_size_3']  = '';
        formData['category_'+i+'_price_3'] = '';
      }
    }
    return {
      schoolCode: this.state.school,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      filename: "フォトアシスト申請_" + Utils.getHyphenationDate(),
      form: formData
    };
  }

  validation = () => {
    let newState = {};
    newState['date_validate_message'] = (()=>{
      if (this.state.start_date === '' || this.state.end_date === '') return '販売期間を設定してください。';
      if (!this.state.start_date.match(/^\d{4}-\d{2}-\d{2}$/)) return '開始日をYYYY-MM-DDの形式で入力してください。';
      if (!this.state.end_date.match(/^\d{4}-\d{2}-\d{2}$/)) return '終了日をYYYY-MM-DDの形式で入力してください。';
      if (this.state.start_date < (new Date()).toLocaleDateString('sv-SE')) return '開始日が過去の日付です。';
      if (this.state.end_date <= this.state.start_date) return '終了日が開始日より前の日付です。';
      return null;
    })();
    newState['event_name_validate_message'] = (()=>{
      if (this.state.event_name === '') return 'イベント名を設定してください。';
      return null;
    })();

    for (let i = 1; i <= 12; i++) {
      newState['category_'+i+'_validate_message'] = (()=>{
        if (this.state.categories.length >= i) {

          if (this.state['category_'+i+'_name'] === '') return 'アップロードフォルダ名を設定してください。';
          if (parseInt(this.state['category_'+i+'_length'],10) <= 0) return '写真点数を入力してください。';

          if (parseInt(this.state['category_'+i+'_price_1'],10) < 0) return '販売価格を設定してください。';

          if (this.state.categories[i-1] === 1) return null;

          if (this.state['category_'+i+'_size_1'] === this.state['category_'+i+'_size_2']) return '販売サイズが重複しています。';
          if (parseInt(this.state['category_'+i+'_price_2'],10) < 0) return '販売価格を設定してください。';
          
          if (this.state.categories[i-1] === 2) return null;

          if (this.state['category_'+i+'_size_1'] === this.state['category_'+i+'_size_3'] || this.state['category_'+i+'_size_2'] === this.state['category_'+i+'_size_3']) return '販売サイズが重複しています。';
          if (parseInt(this.state['category_'+i+'_price_3'],10) < 0) return '販売価格を設定してください。';
        }
        return null;
      })();
    }
    this.setState(newState);
    this.props.changeValidate(Object.values(newState).every(v=>v===null));
  }

  handleClickAddSize = e => {
    e.preventDefault();
    let index = e.target.dataset.index;
    let categories = this.state.categories;
    if (categories[index] >= 3) return;
    categories[index]++;
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }
  handleClickRemoveSize = e => {
    e.preventDefault();
    let index = e.target.dataset.index;
    let categories = this.state.categories;
    if (categories[index] <= 1) return;
    categories[index]--;
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }
  handleClickAddCategory = e => {
    e.preventDefault();
    if (this.state.categories.length >= 12) return;
    let categories = this.state.categories;
    categories.push(1);
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }
  handleClickRemoveCategory = e => {
    e.preventDefault();
    if (this.state.categories.length <= 1) return;
    let categories = this.state.categories;
    categories.pop();
    this.setState({
      categories: categories
    }, () =>{
      this.validation();
    });
  }

  handleChangeValue = e => {
    let newState = {};
    newState[e.target.name] = e.target.value.trim();
    this.setState(newState, () =>{
      this.validation();
    });
  }

  handleMouseDownDatePicker = e => {
    let name = e.target.name;
    this.props.openDatePicker(e.target, value => {
      let newState = {};
      newState[name] = value;
      this.setState(newState, () =>{
        this.validation();
      });
    })
  }

  renderForm = () => {
    return (<form ref={ref=>{this.form=ref}}>

      <div className="formBlock titleBlock">
        <div className="titleBlock-wrap">
          <h2>フォトアシストの申し込み</h2>
          <div>写真販売システムの申し込みフォームです。</div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">対象の学校</div>
        <div className="formBlock-input">
          <select name="school" value={this.state.school} onChange={this.handleChangeValue}>{
            this.props.data.albums.map(a => {
              return <option key={a.code} value={a.code}>{a.hinmei}</option>
            })
          }</select>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">販売種類</div>
        <div className="formBlock-input">
          <select name="offer_type" value={this.state.offer_type} onChange={this.handleChangeValue}>{
            this.offer_types.map((type, i) => {
              return <option key={i}>{type}</option>
            })
          }</select>
        </div>
      </div>


      <div className="formBlock">
        <div className="formBlock-title">販売期間</div>
        <div className="formBlock-message">
          <p>【販売期間目安】</p>
          <p>・アルバム同時販売は3ヶ月間</p>
          {/*<p>・行事販売は1ヶ月間</p>*/}
        </div>
        <div className="formBlock-input">
          <div>
            <label>開始日</label>
            <input name="start_date" onMouseDown={this.handleMouseDownDatePicker} 
              value={this.state.start_date} onChange={this.handleChangeValue} required pattern="^\d{4}-\d{2}-\d{2}$"/>
          </div>
          <div>
            <label>終了日</label>
            <input name="end_date" onMouseDown={this.handleMouseDownDatePicker}
              value={this.state.end_date} onChange={this.handleChangeValue} required pattern="^\d{4}-\d{2}-\d{2}$"/>
          </div>
        </div>
        {!this.state.date_validate_message?null
        :<div className="formBlock-error">{this.state.date_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">イベント名</div>
        <div className="formBlock-input">
          <input name="event_name" value={this.state.event_name} onChange={this.handleChangeValue} required/>
        </div>
        {!this.state.event_name_validate_message?null
        :<div className="formBlock-error">{this.state.event_name_validate_message}</div>}
      </div>

      {
        (()=>{
          let blocks = [];
          for (let i = 1; i <= this.state.categories.length; i++) {
            blocks.push(
              <div className="formBlock" key={i}>
                <div className="formBlock-title">カテゴリー {i}</div>
                <div className="formBlock-input">
                  <label>アップロードフォルダ名</label>
                  <input name={"category_"+i+"_name"} value={this.state["category_"+i+"_name"]} onChange={this.handleChangeValue} required/>
                  <label>写真点数</label>
                  <input type="number" name={"category_"+i+"_length"} value={this.state["category_"+i+"_length"]} onChange={this.handleChangeValue} required/>

                  {(()=>{
                    let sizes = [];
                    for (var j = 1; j <= this.state.categories[i-1]; j++) {
                      sizes.push(
                        <div className="formBlock"key={j}>
                          <label>販売サイズ {j}</label>
                          <div className="formBlock-input">
                            <select name={"category_"+i+"_size_"+j} value={this.state["category_"+i+"_size_"+j]} onChange={this.handleChangeValue}>{
                              this.print_size.map((s,j)=>{
                                return <option key={j}>{s}</option>
                              })
                            }</select>
                          </div>
                          <label>販売価格</label>
                          <div className="formBlock-input">
                            <input type="number" name={"category_"+i+"_price_"+j} value={this.state["category_"+i+"_price_"+j]} 
                              onChange={this.handleChangeValue} required pattern="^\d+$"/>
                          </div>
                          
                          <div className="formBlock-buttons">
                          {j===1||j!==this.state.categories[i-1]?null
                          :<button onClick={this.handleClickRemoveSize} data-index={i-1} data-subindex={j-1}>販売サイズの削除</button>
                          }
                          {j!==this.state.categories[i-1]?null
                          :<button onClick={this.handleClickAddSize} data-index={i-1} disabled={this.state.categories[i-1]>=3}>販売サイズの追加</button>
                          }
                          </div>
                        </div>
                      )
                    }
                    return sizes;
                  })()}
                  
                    
                  <div className="formBlock-buttons">
                  {i===1||i!==this.state.categories.length?null
                  :<button onClick={this.handleClickRemoveCategory}>カテゴリーの削除</button>
                  }
                  {i!==this.state.categories.length?null
                  :<button onClick={this.handleClickAddCategory} disabled={this.state.categories.length>=12}>カテゴリーの追加</button>
                  }
                  </div>
                </div>


                {!this.state['category_'+i+'_validate_message']?null
                :<div className="formBlock-error">{this.state['category_'+i+'_validate_message']}</div>}
              </div>
            )
          }
          return blocks;
        })()
      }


    </form>)
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="formBlock titleBlock">
          <div className="titleBlock-wrap">
            <h2>フォトアシストの申し込み</h2>
            <div>内容をよくご確認の上、ご申請ください。</div>
          </div>
        </div>
        <div className="confirm">
          <div className="confirm-row">
            <label>学校</label>
            <span>{this.props.data.albums.find(a=>a.code===this.state.school).hinmei}</span>
          </div>
          <div className="confirm-row">
            <label>販売種類</label>
            <span>{this.state.offer_type}</span>
          </div>
          <div className="confirm-row">
            <label>販売期間</label>
            <span>{this.state.start_date+' 〜 '+this.state.end_date}</span>
          </div>
          {(()=>{
            let categories = [];
            for (let i = 1; i <= this.state.categories.length; i++) {
              categories.push(
                <div key={i}>
                  <div className="confirm-row"><label>カテゴリー {i}</label></div>
                  <div className="confirm-row" data-indent="1">
                    <label>アップロードフォルダ名</label>
                    <span>{this.state['category_'+i+'_name']}</span>
                  </div>
                  <div className="confirm-row" data-indent="1">
                    <label>写真点数</label>
                    <span>{this.state['category_'+i+'_length']}</span>
                  </div>

                  {(()=>{
                    let sizes = [];
                    for (let j = 1; j <= this.state.categories[i-1]; j++) {
                      sizes.push(
                        <div key={j}>
                          <div className="confirm-row" data-indent="1">
                            <label>販売サイズ {j}</label>
                          </div>
                          <div className="confirm-row" data-indent="2">
                            <label>販売サイズ</label>
                            <span>{this.state['category_'+i+'_size_'+j]}</span>
                          </div>
                          <div className="confirm-row" data-indent="2">
                            <label>販売価格</label>
                            <span>{this.state['category_'+i+'_price_'+j]}</span>
                          </div>
                        </div>
                      )
                    }
                    return sizes;
                  })()}
                </div>
              )
            }
            return categories;
          })()}
        </div>
      </div>
    )
  }

  render () {
    switch (this.props.progress) {
      case 'form': return this.renderForm();
      case 'confirm': return this.renderConfirm();
      default: return null;
    }
  }
}
export default PhotoAssistForm;